@if (
  (isEOMLoading$ | async) ||
  (isBridgingToSDKQSet$ | async) ||
  (areQuotesLoading$ | async) ||
  (isQueSetLoading$ | async) ||
  (isAppFormLoading$ | async) ||
  (isSyncedWithBP$ | async) === false) {
  <div
    class="loading-screen-wrapper"
    >
    <mat-spinner aria-label="Loading"></mat-spinner>
  </div>
} @else {
  <application-form-web-component
    [activeMenuOrder$]="activeMenuOrder$"
    [isReferred]="isReferred"
    [readOnlyMode$]="readOnlyMode$"
    [data]="sdkInitData"
    [applicationHost]="'BP'"
    [application_state$]="appFormState$"
    [carrierProducts$]="carrierProducts$"
    [isOwner$]="isOwner$"
    (onInputvalueChange)="onInputValueChange($event)"
    (onSaveButtonClick)="onSaveButtonClicked($event)"
    (onSaveButtonBlur)="onSaveButtonBlurred($event)"
    (onSaveButtonFocus)="onSaveButtonFocused($event)"
    (onInputInit)="onInputInit($event)"
    (onQuoteBind)="onQuoteBindCalled($event)"
    (onExploreMarketsClick)="onExploreMarketsClicked($event)"
    (onQuoteViewDetailsClick)="onQuoteViewDetailsClicked($event)"
    (onQuoteRequestView)="onQuoteRequestView($event)"
    >
  </application-form-web-component>
}
